export default "__VITE_ASSET__BhGDpCot__"